export enum eTypeWorkOrder{
    Inbound = 1,
    Outbound =2,
    Mantención = 3,
    Recall = 4,
    PreSale = 5
}